import citizen_contract from '../../../build/contracts/Citizens.json'
import democracy_contract from '../../../build/contracts/Democracy.json'
import token_contract from '../../../build/contracts/Token.json'
import store from '../../store'

const contract = require('truffle-contract')

export const SET_NEW_PROPOSAL = 'SET_NEW_PROPOSAL'
function proposalUpdated(info) {
    return {
        type: SET_NEW_PROPOSAL,
        payload: info
    }
}

export const SET_PAY_TAX = 'SET_PAY_TAX'
function payTaxUpdated(info) {
    return {
        type: SET_PAY_TAX,
        payload: info
    }
}

export const SET_EDIT_NAME = 'SET_EDIT_NAME'
function editNameUpdated(info) {
    return {
        type: SET_EDIT_NAME,
        payload: info
    }
}

export const INIT_BALANCE = 'INIT_BALANCE'
function walletUpdated(balance) {
    return {
        type: INIT_BALANCE,
        payload: balance
    }
}

export const SET_CITIZENS = 'SET_CITIZENS'
function citizensUpdated(citizens) {
    return {
        type: SET_CITIZENS,
        payload: citizens
    }
}

export function getBalance(address) {
  
    let web3 = store.getState().web3.web3Instance

    if (typeof web3 !== 'undefined') {

        return function(dispatch) {
		
            let addressBalance = ''

            web3.eth.getBalance(address, function(error, result){
                if(!error){
                    addressBalance = web3.fromWei(result) + " ETH" 
                    return dispatch(walletUpdated(addressBalance))
		
                } else {
                    console.error(error);
                    return dispatch(walletUpdated("N/N"))
		
                }
            })
        }
    } else {
        console.error('Web3 is not initialized.');
    }
}

export function getEditNameInfo(address) {
  
    let web3 = store.getState().web3.web3Instance

    if (typeof web3 !== 'undefined') {

        return function(dispatch) {
		
            let cInstance
            let id = 'N-N'
            let balanceIn ='N-N'
            let citizenName ='N-N'
		
            const CitizenContract = contract(citizen_contract)
            CitizenContract.setProvider(web3.currentProvider)
            const DemocracyContract = contract(democracy_contract)
            DemocracyContract.setProvider(web3.currentProvider)

            CitizenContract.deployed().then((contractInstance) => {
                cInstance = contractInstance	
			
                return cInstance.memberId(address)
            }).then((result) => {
			
                id = result.toString()
                return cInstance.members(id)
            }).then((result) => {
			
                citizenName = result[1]
			
                DemocracyContract.deployed().then((contractInstance) => {
                    cInstance = contractInstance	

                    return cInstance.balanceOf(address)
                }).then((result) => {
				
                    let paid = parseFloat(web3.fromWei(result.toString()));
                    balanceIn = paid + " ETH"
				
                    return dispatch(editNameUpdated({'memberId':id,'balanceIn':balanceIn,'citizenName':citizenName}))
                })

            })
		
        }
    } else {
        console.error('Web3 is not initialized.');
    }
}

export function getPayTaxInfo(address) {
  
    let web3 = store.getState().web3.web3Instance

    if (typeof web3 !== 'undefined') {

        return function(dispatch) {
		
            let cInstance
            let id = 'N-N'
            let balanceIn ='N-N'
		
            const CitizenContract = contract(citizen_contract)
            CitizenContract.setProvider(web3.currentProvider)
            const DemocracyContract = contract(democracy_contract)
            DemocracyContract.setProvider(web3.currentProvider)

            CitizenContract.deployed().then((contractInstance) => {
                cInstance = contractInstance	
			
                return cInstance.memberId(address)
            }).then((result) => {
			
                id = result.toString()
				
                DemocracyContract.deployed().then((contractInstance) => {
                    cInstance = contractInstance	

                    return cInstance.balanceOf(address)
                }).then((result) => {
				
                    let paid = parseFloat(web3.fromWei(result.toString()));
                    balanceIn = paid + " ETH"
				
                    return dispatch(payTaxUpdated({'memberId':id,'balanceIn':balanceIn}))
                })

            })
		
        }
    } else {
        console.error('Web3 is not initialized.');
    }
}

export function getNewProposalInfo(address) {
  
    let web3 = store.getState().web3.web3Instance

    if (typeof web3 !== 'undefined') {

        return function(dispatch) {
		
            let cInstance
            let id = 'N-N'
            let balanceInToken = 'N-N'
            let balanceIn ='N-N'
		
            const CitizenContract = contract(citizen_contract)
            CitizenContract.setProvider(web3.currentProvider)
            const DemocracyContract = contract(democracy_contract)
            DemocracyContract.setProvider(web3.currentProvider)
            const TokenContract = contract(token_contract)
            TokenContract.setProvider(web3.currentProvider)
				
            CitizenContract.deployed().then((contractInstance) => {
                cInstance = contractInstance	
			
                return cInstance.memberId(address)
            }).then((result) => {
			
                id = result.toString()
					
                TokenContract.deployed().then((contractInstance) => {
                    cInstance = contractInstance	
				
                    return cInstance.balanceOf(address)
                }).then((result) => {
				
                    let token = parseFloat(web3.fromWei(result.toString()));
                    balanceInToken = token + " ETH"
				
                    DemocracyContract.deployed().then((contractInstance) => {
                        cInstance = contractInstance	

                        return cInstance.balanceOf(address)
                    }).then((result) => {
					
                        let paid = parseFloat(web3.fromWei(result.toString()));
                        balanceIn = paid + " ETH"
					
                        return dispatch(proposalUpdated({'memberId':id,'balanceInToken':balanceInToken,'balanceIn':balanceIn}))
                    })
				
                })
			
            })
		
        }
    } else {
        console.error('Web3 is not initialized.');
    }
}

export function getCitizensInfo(address) {
  
    let web3 = store.getState().web3.web3Instance

    if (typeof web3 !== 'undefined') {

        return function(dispatch) {
		
            let cInstance
            let id = 'N-N'
            let citizensNum = 'N-N'
            let balanceIn ='N-N'

            const CitizenContract = contract(citizen_contract)
            CitizenContract.setProvider(web3.currentProvider)
            const DemocracyContract = contract(democracy_contract)
            DemocracyContract.setProvider(web3.currentProvider)
			
            CitizenContract.deployed().then((contractInstance) => {
                cInstance = contractInstance	
			
                return cInstance.memberId(address)
            }).then((result) => {
			
                id = result.toString()
                return cInstance.numCitizens()
            }).then((result) => {
			
                citizensNum = result.toString()
			
                DemocracyContract.deployed().then((contractInstance) => {
                    cInstance = contractInstance	
				
                    return cInstance.balanceOf(address)
                }).then((result) => {
				
                    let paid = parseFloat(web3.fromWei(result.toString()));
                    balanceIn = paid + " ETH"
				
                    return dispatch(citizensUpdated({'memberId':id,'citizensNum':citizensNum,'balanceIn':balanceIn}))
				
                })
			
            })
		
        }
    } else {
        console.error('Web3 is not initialized.');
    }
}



// WEBPACK FOOTER //
// ./src/user/actions/GetInfo.js